import React, { useContext, useEffect, useState } from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { availabilityPickerContext } from 'src/contexts/availabilityPicker';
import { useSelector } from 'src/store';
import { useNavigate } from 'react-router-dom';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function UnavailableTimeSlot() {
    const dateTime = useSelector(state => state.appointment.dateTime)
    const { setOpen } = useContext(availabilityPickerContext);
    const [initialDateTime] = useState(dateTime);
    const navigate = useNavigate();

    useEffect(() => {
        if (dateTime !== initialDateTime) {
            navigate("/app/reserve-booking")
        }
    }, [dateTime, initialDateTime, navigate])

    return (<>
        <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium">
                Unavailable time slot
            </h1>
            <p>
                We are sorry, but this time slot is no longer available.
                <br />Please select another date and time.
            </p>
            <p>
                If you don’t have an existing record,
                please exit and select 'New patient'. Alternatively, contact the clinic directly for assistance.
            </p>

        </ContentContainer>
        <StickyBottomBar>
            <Button className="w-full"
                color='gray'
                onClick={() => setOpen(true)} >
                Choose a new date and time
            </Button>
        </StickyBottomBar>
    </>
    );
}
